import { memo, useLayoutEffect, ReactNode } from 'react';
import { css } from '@emotion/css';
import { Modal, ModalProps } from 'antd';

const className = css`
  .ant-modal-mask,
  .ant-modal-wrap {
    position: absolute;
  }
`;

export interface SiderModalProps extends ModalProps {
  sider?: HTMLElement;
  children?: ReactNode;
}

function SiderModal(props: SiderModalProps) {
  const { sider, ...otherProps } = props;

  useLayoutEffect(() => {
    if (sider) {
      sider.classList.add(className);
    }
  }, [sider]);

  return <Modal getContainer={() => sider || document.body} {...otherProps} />;
}

export default memo(SiderModal);
